import { render } from "./FaqServiceComp.vue?vue&type=template&id=36a09dcf&ts=true"
import script from "./FaqServiceComp.vue?vue&type=script&lang=ts"
export * from "./FaqServiceComp.vue?vue&type=script&lang=ts"

import "./FaqServiceComp.vue?vue&type=style&index=0&id=36a09dcf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__